<template>
  <div class="title-screen-chapter-three">

    <two-columns
      :greyBackground="true"
      :grid="{colOne: {cols: 'col-3'}, colTwo: {cols: 'col-5'},}"
    >
      <template v-slot:left-column>
        <div class="centered-content">
          <h1 class="no-margin-bottom" v-if="data.title">
            {{ data.title }}
          </h1>
          <h4 class="no-margin-top dark" v-if="data.subtitle">{{ data.subtitle }}</h4>
          <div v-if="data.body" v-html="data.body"></div>
        </div>

      </template>
      <template v-slot:right-column>
          <v-lottie-player
            class="lottie-video-player"
            autoplay
            loop
            :animationData="data.animation"
            height="300"
            width="300"
          />
      </template>
    </two-columns>
  </div>
</template>

<script>
import TwoColumns from '@/components/widgets/TwoColumns.vue'
export default {
  props: ['data'],
  components: {
    TwoColumns
  },
}
</script>
<style lang="scss">
.title-screen-chapter-three{
  .grey-border{
    position: absolute;
    bottom: 0px;
    right: 0px;
    left: 0px;
    background-color: #EDF2F5;
    height: 87px;
  }
}
@media screen and (max-width: 992px) {
  .title-screen-chapter-three{
    .grey-border{
    display: none;
    }
  }
}
</style>